import { type FC } from 'react';

type Props = {
  width?: number;
  height?: number;
};

export const InfoIcon: FC<Props> = ({ width = 36, height = 36 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36.7998 0H0.799805V36H36.7998V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M8.29395 28.365V8.668C8.32971 7.58901 8.79198 6.56826 9.57934 5.82964C10.3667 5.09102 11.4149 4.69484 12.4939 4.728H29.3049V25.739H12.4939C9.18795 25.739 8.29395 26.188 8.29395 28.365Z"
        fill="white"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9195 30.9923H29.3045V25.7393H10.9195C10.2229 25.7393 9.55482 26.016 9.06225 26.5085C8.56969 27.0011 8.29297 27.6692 8.29297 28.3658C8.29297 29.0623 8.56969 29.7304 9.06225 30.223C9.55482 30.7155 10.2229 30.9923 10.9195 30.9923Z"
        fill="white"
        stroke="#2F353E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18.7998 14.8091V20.7181V14.8091Z" fill="#2F353E" />
      <path d="M18.7998 14.8091V20.7181" stroke="#2F353E" strokeWidth="2.5" strokeLinecap="round" />
      <path
        d="M19.6318 10.3599C19.6318 10.8199 19.2589 11.1929 18.7988 11.1929C18.3388 11.1929 17.9658 10.8199 17.9658 10.3599C17.9658 9.8998 18.3388 9.52686 18.7988 9.52686C19.2589 9.52686 19.6318 9.8998 19.6318 10.3599Z"
        fill="#2F353E"
        stroke="#2F353E"
      />
    </svg>
  );
};
